import { has } from 'lodash';
import constants from '../Constants';

const { STATS, STATS_LOADING, STATS_CHANGE, LOGOUT } = constants;

const INIT_STATE = { stats:[], statsLoading: true };

const DashboardReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STATS:
      return { ...state, stats: action.payload, statsLoading: false };
    case STATS_LOADING:
      return { ...state, statsLoading: true };
    case STATS_CHANGE:
      const { payload: { id, increment } } = action;
      const stats = changeStats(state.stats, id, increment );
      return {...state, stats };
    case LOGOUT:
      return INIT_STATE;
    default:
        return state;
  }
}

export default DashboardReducer;

const changeStats = (stats, id, increment ) => {
  if(has(stats,id)){
    const total = increment ? stats[id].total+1 : stats[id].total-1; 
    return { ...stats, [id]: { sid: id, total } };
  }else{
    return { ...stats, [id]: { sid: id, total: 1} };
  }
}


// WEBPACK FOOTER //
// ./src/Reducers/DashboardReducer.js